var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.surveyHasMultipleLanguages)?_c('div',{attrs:{"id":"multiLanguage"}},[_c('v-select',{attrs:{"items":_vm.languages,"label":"Survey Language","value":_vm.activeLanguage,"return-object":"","data-cy":"language-select"},on:{"change":_vm.languageSelected}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }